const iosDeviceMapping = new Map([
    ["320x480", "IPhone 4S, 4, 3GS, 3G, 1st gen"],
    ["320x568", "IPhone 5, SE 1st Gen,5C, 5S"],
    ["375x667", "IPhone SE 2nd Gen, 6, 6S, 7, 8"],
    ["375x812", "IPhone X, XS, 11 Pro, 12 Mini, 13 Mini"],
    ["390x844", "IPhone 13, 13 Pro, 12, 12 Pro"],
    ["414x736", "IPhone 8+"],
    ["414x896", "IPhone 11, XR, XS Max, 11 Pro Max"],
    ["428x926", "IPhone 13 Pro Max, 12 Pro Max"],
    ["476x847", "IPhone 7+, 6+, 6S+"],
    ["744x1133", "IPad Mini 6th Gen"],
    ["768x1024", "IPad Mini (5th Gen), IPad (1-6th Gen), iPad Pro (1st Gen 9.7), Ipad Mini (1-4), IPad Air(1-2)"],
    ["810x1080", "IPad 7-9th Gen"],
    ["820x1180", "iPad Air (4th gen)"],
    ["834x1194", "iPad Pro (3-5th Gen 11)"],
    ["834x1112", "iPad Air (3rd gen), iPad Pro (2nd gen 10.5)"],
    ["1024x1366", "iPad Pro (1-5th Gen 12.9)"],
]);

function getAndroidDeviceName() {
    if (typeof window === "undefined" || typeof navigator === "undefined") return "Android";

    const ua = window.navigator.userAgent;
    const androidIndex = ua.indexOf("Android");
    if (androidIndex === -1) return "Android";

    const androidUserAgentString = ua.slice(androidIndex);
    const start = androidUserAgentString.indexOf("; ") + 2;
    const end = androidUserAgentString.indexOf(")");
    const androidDeviceName = androidUserAgentString.slice(start, end);

    return androidDeviceName ? androidDeviceName.trim().split(" ")[0] : "Android";
}

function getIosDeviceName() {
    if (typeof window === "undefined") return "Iphone";

    const screenResolution = `${window.screen.width}x${window.screen.height}`;
    return iosDeviceMapping.get(screenResolution) || "Iphone";
}

function isIpad() {
    if (typeof window === "undefined" || typeof navigator === "undefined") return false;

    const ua = navigator.userAgent || "";
    const platform = navigator.platform || "";
    const touchPoints = navigator.maxTouchPoints || 0;

    const screenRes = `${window.screen.width}x${window.screen.height}`;
    const isIpadResolution = iosDeviceMapping.has(screenRes);

    // Covers both real iPads and iPads reporting as Macs
    return ua.includes("iPad") || (platform === "MacIntel" && touchPoints > 1 && isIpadResolution);
}

function isAndroidTablet() {
    if (typeof window === "undefined" || typeof navigator === "undefined") return false;

    const ua = navigator.userAgent.toLowerCase();
    const minTabletWidth = 768; // heuristic: tablets usually ≥ 768px wide

    return ua.includes("android") && !ua.includes("mobile") && window.screen.width >= minTabletWidth;
}

function getDesktopDeviceName() {
    if (typeof navigator === "undefined") return "Unknown";

    const platform = navigator.userAgentData?.platform || navigator.platform || "";
    const ua = navigator.userAgent || "";

    if (isIpad()) return "iPad"; // override before detecting Mac

    if (platform.includes("Mac") || ua.includes("Mac OS")) return "Mac OS";
    if (platform.includes("Win") || ua.includes("Windows")) return "Windows";
    if (platform.includes("Linux") || ua.includes("Linux")) return "Linux";

    return "Unknown";
}

export default function getDeviceInfo() {
    if (typeof window === "undefined" || typeof navigator === "undefined") {
        return {deviceType: "unknown", deviceName: "Unknown"};
    }

    const ua = window.navigator.userAgent.toLowerCase();
    const isMobile = ua.includes("mobi") || ua.includes("android") || ua.includes("iphone") || ua.includes("ipad");

    let deviceType = "desktop";
    let deviceName = "";

    if (isIpad()) {
        deviceType = "tablet";
        deviceName = getIosDeviceName();
    } else if (isAndroidTablet()) {
        deviceType = "tablet";
        deviceName = getAndroidDeviceName();
    } else if (isMobile) {
        deviceType = "mobile";
        deviceName = ua.includes("android") ? getAndroidDeviceName() : getIosDeviceName();
    } else {
        deviceName = getDesktopDeviceName();
    }

    return {deviceType, deviceName};
}
